export default "/assets/8c4d7811464526b0.svg"